import React from 'react';
import classnames from 'classnames/bind';
import { Loader } from '../../components/Loader';
import { NoData } from '../../components/NoData';
import CustomLink from '../../components/CustomLink';
import { useDocumentTitle } from '../../shared/use-document-title';
import { usePayments } from '../../shared/use-payments';
import { useRouting } from '../../shared/use-routing';
import { pagePathnames } from '../page-routes';
import styles from './AccountPaymentHistoryPage.css';

const cx = classnames.bind(styles);

function AccountPaymentHistoryPage() {
    const { payments, isLoading } = usePayments();
    const { buildPath } = useRouting();

    useDocumentTitle('Payment History');

    const renderContent = () => {
        if (isLoading) {
            return (
                <div className={styles.loaderWrapper}>
                    <Loader variant='secondary' />
                </div>
            );
        }

        if (payments.length === 0) {
            return (
                <NoData title='No Payment History'>
                    <p>You haven’t made any purchases yet.</p>
                </NoData>
            );
        }

        return (
            <ul className={styles.payments}>
                {payments.map(paymentData => (
                    <li
                        key={paymentData.id}
                        className={styles.paymentCard}
                    >
                        <div className={cx('paymentCardHeader', 'blockWithBorder')}>
                            <time dateTime={`${paymentData.date}, ${paymentData.time}`} className={styles.date}>{paymentData.date}, <span>{paymentData.time}</span></time>
                            <p className={styles.paymentCardAmount}>{paymentData.amount}</p>
                        </div>
                        <ul className={styles.paymentCardInfoItems}>
                            <li className={styles.paymentCardInfoItem}>
                                <span>What you bought</span>
                                <span>
                                    <CustomLink to={buildPath(`${paymentData.productHash.includes('subscription') ? pagePathnames.account : pagePathnames.purchases}#${paymentData.productHash}`)}>
                                        {paymentData.productName}
                                    </CustomLink>
                                </span>
                            </li>
                            <li className={styles.paymentCardInfoItem}>
                                <span>Payment method</span>
                                <span>{paymentData.method}</span>
                            </li>
                            <li className={styles.paymentCardInfoItem}>
                                <span>Appears on your statement as</span>
                                <span>{paymentData.descriptor || '—'}</span>
                            </li>
                        </ul>
                    </li>
                ))}
            </ul>
        );
    };

    return renderContent();
}

export {
    AccountPaymentHistoryPage
};
